import { trans } from '@spotahome/soyuz/client';

export default () => [
  {
    id: 'fsingle-id',
    value: 'single-group',
    label: trans('search.applied-filters-modal.bed.single-group'),
    tracking: 'ga-search-form-toggle-single-bed',
    icon: 'single_bed',
    cy: 'bed-single-group'
  },
  {
    id: 'fdouble-id',
    value: 'double',
    label: trans('search.applied-filters-modal.bed.double'),
    tracking: 'ga-search-form-toggle-double-bed',
    icon: 'double_bed',
    cy: 'bed-double'
  },
  {
    id: 'ftwin-id',
    value: 'twin',
    label: trans('search.applied-filters-modal.bed.twin'),
    tracking: 'ga-search-form-toggle-twin-beds',
    icon: 'single_bed',
    cy: 'bed-twin'
  }
];
